export const reportConversion = () => {
  if (typeof window !== 'undefined' && window.gtag_report_conversion) {
    return window.gtag_report_conversion();
  } else {
    return false;
  }
};
